import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from "vuex-class";
import {
  APARTMENT_DELETE_ZONE,
  APARTMENT_GET_ZONE,
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_PATCH_ZONE,
  APARTMENT_POST_ZONE, APARTMENT_SEARCH_ZONE,
  APARTMENT_SET_ZONE_ACTION
} from "../../../store/apartment";
import {CrudStatus} from "../../../common/enums";
import {IApartmentParameter} from "../../../models/apartment";

const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)

@Component({
  components: {
    'profile-table-loader': async () => import('@/containers/profile/loaders/profile-pagination-loader/ProfilePaginationLoader.vue')
  },
  filters: {}
})
class BlockZones extends Vue {
  dtSearch: string;
  dtSource: any[];
  dtIsLoading: boolean;
  dtPage: number;
  dtTotalPage: number;
  dtMessageErrorModel: boolean
  dtError: any
  dtOpenModal: boolean
  dtIsUpdateModal: boolean
  dtZoneSelected: any
  dtIsDeleteZone: boolean
  nameZone: string
  dtRules: {
    namesRules?: any;
  }

  _clearTimeout: any

  constructor () {
    super()
    this.dtSearch = null
    this.dtSource = []
    this.dtIsLoading = false
    this.dtPage = 1
    this.dtTotalPage = null
    this.dtMessageErrorModel = false
    this.dtError = null
    this.dtOpenModal = false;
    this.dtIsUpdateModal = false;
    this.dtIsDeleteZone = false;
    this.dtZoneSelected = null;
    this.nameZone = null;
  }

  // @ApartmentStore.Getter currentApartmentZone: any[]
  @ApartmentStore.Getter apartmentParameter: IApartmentParameter;
  @ApartmentStore.Getter zoneAction: CrudStatus
  @Watch('zoneAction')
  onZoneCrudActionChange(newVal: CrudStatus) {
    if (newVal === CrudStatus.Create) this.dtOpenModal = true
  }

  @ApartmentStore.Mutation(APARTMENT_SET_ZONE_ACTION)
  storeSetZoneAction: (action: CrudStatus) => void;

  @ApartmentStore.Action(APARTMENT_GET_ZONE)
  storeGetApartmentZones: (apartmentId) => Promise<any>

  @ApartmentStore.Action(APARTMENT_SEARCH_ZONE)
  storeSearchApt: (payload: { apartments: number[], q: string, $skip?, $limit? }) => Promise<any>;

  @ApartmentStore.Action(APARTMENT_POST_ZONE)
  storePostApartmentZone: (payload) => Promise<any>

  @ApartmentStore.Action(APARTMENT_PATCH_ZONE)
  storePatchApartmentZone: (payload) => Promise<any>

  @ApartmentStore.Action(APARTMENT_DELETE_ZONE)
  storeDeleteApartmentZone: (payload) => Promise<any>

  get lblSetting () {
    return {
      ...require('@/locales/apartment').default
    }
  }

  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }

  get modalTitle () {
    if (this.dtIsUpdateModal) return this.$t(this.lblSetting.apartmentZoneModalTitleUP)
    return this.$t(this.lblSetting.apartmentZoneModalTitle)
  }

  get coSource () {
    return /* this.currentApartmentZone */ this.dtSource || []
  }

  get coTableHeaders (): any[] {
    return [
      {
        text: this.$t(this.lblSetting.apartmentZoneName),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        value: 'modifier & supprimer',
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title hidden'
      }
    ]
  }

  get manageZone () {
    if (!localStorage.getItem('block_apartment_details')) return false
    return JSON.parse(localStorage.getItem('block_apartment_details')).manage_apartment_zone || false
  }

  created () {
    this.handleGetZones()
  }

  mounted () {
    this.dtRules = {
      namesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartmentZoneName)})
      ]
    }
  }

  @Watch('dtPage')
  handlePageChange (value: number) {
    this.handleGetZones()
  }

  @Watch('apartmentParameter.key')
  handleParamChanged (value) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.handleGetZones(true)
    }, 500)
  }

  handleGetZones (needReset: boolean = false) {
    this.dtIsLoading = true
    if (needReset) {
      this.dtPage = 1
    }
    this.storeSearchApt({
      apartments: [parseInt(this.$route.params.cid, 10)],
      q: this.apartmentParameter.key,
      $skip: (this.dtPage - 1) * 10,
      $limit: 10,
    })
      .then(response => {
        this.dtSource = response.data
        this.dtTotalPage = Math.ceil(response.total / 10)
      })
      .finally(() => {
        this.dtIsLoading = false
      })
  }

  handleDeleteZoneCancel () {
    this.dtIsDeleteZone = false
    this.handleClose()
  }

  handleOpenDeleteZone (zone) {
    this.dtIsDeleteZone = true
    this.dtZoneSelected = zone
  }

  handleDeleteZoneOK () {
    this.dtIsLoading= true
    this.storeDeleteApartmentZone({
      apartmentId: this.$route.params.cid,
      zoneId: this.dtZoneSelected.id
    })
      .then(res => {
        this.dtIsDeleteZone = false
        const index = this.dtSource.findIndex(x => x.id === res.id);
        if (index > -1) {
          this.dtSource.splice(index, 1);
        }
      })
      .catch(err=>{
        this.dtMessageErrorModel= true
        this.dtError= err
      })
      .finally(()=>{
        this.dtIsLoading= false
      })
  }

  handleUpdateModal(zone) {
    this.dtOpenModal = true
    this.dtIsUpdateModal = true
    this.dtZoneSelected = zone
    this.nameZone = zone.name
  }

  handleSaveModal () {
    this.dtIsLoading= true
    // is update
    if (this.dtIsUpdateModal) {
      this.storePatchApartmentZone({
        apartmentId: this.$route.params.cid,
        zoneId: this.dtZoneSelected.id,
        params: {name: this.nameZone}
      })
        .then(res => {
          this.dtOpenModal = false
          const index = this.dtSource.findIndex(x => x.id === res.id)
          if (index > -1) {
            this.dtSource.splice(index, 1, res);
          }
          this.nameZone = ''
        })
        .catch(err=>{
          this.dtMessageErrorModel= true
          this.dtError= err
        })
        .finally(()=>{
          this.dtIsLoading= false
        })
    } else {
      this.storePostApartmentZone({
        apartmentId: this.$route.params.cid,
        params: {name: this.nameZone}
      })
        .then(res => {
          this.dtOpenModal = false
          this.storeSetZoneAction(CrudStatus.NoAction)
          this.dtSource.push(res)
          this.nameZone = ''
        })
        .catch(err=>{
          this.dtMessageErrorModel= true
          this.dtError= err
        })
        .finally(()=>{
          this.dtIsLoading= false
        })
    }
  }

  handleClose(){
    this.dtIsUpdateModal = false
    this.dtZoneSelected = null
    this.nameZone = null
    this.storeSetZoneAction(CrudStatus.NoAction)
  }

  handleBeforeModalClose () {

  }

  handleCloseErrorModal () {
    this.dtMessageErrorModel = false
    this.dtError = null
  }
}

export default BlockZones



// WEBPACK FOOTER //
// ./src/containers/block/block-zones/index.ts